<div class="wrapper">
  <div class="content-wrapper">
    <div class="spacecls"></div>
    <div class="col-md-12 ">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb breadcrumb_dashboard">
        <li>
          <span class="fontnormal"><img src="assets/images/home_india.svg" class="home_india"></span>
        </li>
        <li class="breadcrumb-item"> India</li>
        <li *ngFor="let b of breadCrumbArr; let isLast=last;"
          class="breadcrumb-item"
          [ngClass]="{'active' : isLast}"
          >
          <a *ngIf="!isLast" (click)="headerTextLbl= b.type;nextLevel(b.type, state_id, district_id)">{{b.name}}</a>
          <a *ngIf="isLast">{{b.name}}</a>
        </li>
        </ol>
      </nav>
    </div>
    <section class="content  main-card-block">
      <div class="container-fluid">
        <div class="row">
          <section class="col-lg-4 connectedSortable">
            <div class="card" >
              <div class="card-header">
                <h3 class="card-title blocktitle">
                  Registration Trend - {{todaysdate | date: 'dd/MM/yyyy'}}
                </h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas
                  *ngIf="!deviceService.isMobile(); else mobileRegistationTrendsCNVS"
                  id="registationTrends"
                  width="600"
                  height="300"
                ></canvas>
                <ng-template #mobileRegistationTrendsCNVS>
                  <canvas id="registationTrends" width="600" height="400"></canvas>
                </ng-template>
              </div>
            </div>
          </section>
          <section class="col-lg-4 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">Registrations - {{totalRegistrations | numberFormat }} </h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas *ngIf="!deviceService.isMobile() else registrationPieCanvas"  id='total-registrations' width="300" height="160"></canvas>
                    <ng-template #registrationPieCanvas>
                      <canvas id="total-registrations" width="300" height="133"></canvas>
                </ng-template>
              </div>
            </div>
          </section>
          <section class="col-lg-4 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">Appointments Scheduled</h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas id='lastFiveAppointmentScheduled' width="400" height="200"></canvas>
              </div>
            </div>
          </section>
        </div>
        <div class="row">
          <section class="col-lg-6 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">Registrations by Age <span class="reg_tooltip" tooltip="Includes All FLW, HCW & General Citizens" placement="bottom">
                <img class="infoicon" src="assets/images/info_icon.svg">
                </span></h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas *ngIf="!deviceService.isMobile() else RegByAgeCanvas"  id='registrationsByAge' width="330" height="133"></canvas>
                    <ng-template #RegByAgeCanvas>
                      <canvas id="registrationsByAge" width="600" height="400"></canvas>
                </ng-template>
              </div>
            </div>
          </section>
          <section class="col-lg-6 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">Registrations Vs Appointments</h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas
                  *ngIf="!deviceService.isMobile(); else materialPieCanvas"
                  id="registration-appointments"
                  width="600"
                  height="240"
                ></canvas>
                <ng-template #materialPieCanvas>
                  <canvas id="registration-appointments" width="600" height="400"></canvas>
                </ng-template>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  </div>
